import { render, staticRenderFns } from "./testItem.vue?vue&type=template&id=468722d2&scoped=true&"
import script from "./testItem.vue?vue&type=script&lang=js&"
export * from "./testItem.vue?vue&type=script&lang=js&"
import style0 from "./testItem.vue?vue&type=style&index=0&id=468722d2&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468722d2",
  null
  
)

export default component.exports